/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react';

import { UserContext } from '../../context';
import VideoPlayerStore from '../../store/VideoPlayerStore';


const RelatedSegmentsListVertical = (props) => {
  const handleResize = () => {
    const videoHeight = document.getElementById('vp_18_wrapper').offsetHeight;
    document.getElementById('related-vertical-wrapper').style.maxHeight =
      `${videoHeight}px`;
  };

  useEffect(() => {
    if (!isMobile) {
      window.addEventListener('resize', handleResize);
      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
  }, [handleResize]);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) {
      month = `0${month}`;
    }
    if (day.length < 2) {
      day = `0${day}`;
    }

    return [year, month, day].join('/');
  };

  const { changeVideoSrc, openSubscriptionModal } = props;
  const { programSegments, currentPosition, program, titleDate } = VideoPlayerStore;

  return (
    <>
      <div
        className={`related-vertical-wrapper ${isMobile &&
        'related-mobile-wrapper'}`}
        id="related-vertical-wrapper"
      >
        {isMobile && !props.isPromoActive && (
          <div className="player-title-name">
            <h3>{programSegments?.[currentPosition]?.segment?.name !== '' ? programSegments?.[currentPosition]?.segment?.name : program?.nextSegmentCategory}</h3>
            <p>{titleDate}</p>
          </div>
        )}

        {programSegments?.length &&
        programSegments.map((programSegment, index) => (
          <div
            key={index}
            className={`related-vertical-item ${index === currentPosition &&
                'now-playing-wrapper'}`}
          >
            <a
              className="related-img-wrapper"
              href={'#'}
              onClick={() => changeVideoSrc(programSegment, index)}
            >
              <img
                alt={programSegment.segment.name !== '' ? programSegment.segment.name : program.nextSegmentCategory}
                className="related-img"
                src={programSegment.clip && programSegment.clip.thumbnailImageUrl ? programSegment.clip.thumbnailImageUrl : program.clip.thumbnailImageUrl}
              />
              {index === currentPosition && (
                <div className="related-now-playing">
                  <p>NOW PLAYING</p>
                </div>
              )}
            </a>
            <a
              className="white related-vertical-link"
              href={'#'}
              onClick={(e) => changeVideoSrc(programSegment, index)}
            >
              {programSegment.segment.name !== '' ? programSegment.segment.name : program.nextSegmentCategory}
            </a>
          </div>
        ))}

        <UserContext.Consumer>
          {(value) =>
            isMobile &&
          value.user &&
          !value.user.activeSubscription && (
          <div className="subscribe-btn-wrapper subscribe-btn-wrapper-mobile">
                <button className="subscribe-btn" onClick={openSubscriptionModal}>
              SUBSCRIBE
                </button>
              </div>
            )
          }
        </UserContext.Consumer>
      </div>
      {props.isPromoActive ? <div className="promo-player-title-name">
        <h3>{programSegments[currentPosition].segment.name !== '' ? programSegments[currentPosition].segment.name : program.nextSegmentCategory}</h3>
        <p>{titleDate}</p>
      </div> : ''}
    </>
  );
};

export default observer(RelatedSegmentsListVertical);
